
import { defineComponent, PropType } from 'vue'
import Dropdown from 'primevue/dropdown'

import { EXERCISE_DATA_STYLE_DEFAULT, EXERCISE_DATA_STYLE_OPTIONS } from './exercise-data-style'

type ExerciseDataStyle = 'SingleData' | 'CombinationData' | 'LocationData'

export default defineComponent({
  name: 'ExerciseDataStyleInput',
  components: { Dropdown },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String as PropType<ExerciseDataStyle | undefined>,
      default: undefined,
    },
    fieldName: {
      type: String,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      options: EXERCISE_DATA_STYLE_OPTIONS,
    }
  },
  computed: {
    selectedValue(): ExerciseDataStyle {
      return this.modelValue ?? EXERCISE_DATA_STYLE_DEFAULT
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value: ExerciseDataStyle | undefined) {
        if (value == null) this.$emit('update:modelValue', EXERCISE_DATA_STYLE_DEFAULT)
      },
    },
  },
  methods: {
    updateValue(value: ExerciseDataStyle): void {
      this.$emit('update:modelValue', value)
    },
  },
})
